<template>
    <div class="c-single-car-payments__wrapper">
        <div class="c-single-car-payments">
            <div class="c-single-car-payments__title__wrapper">
                <h2 class="c-single-car-payments__title">Estimez vos paiements</h2>
            </div>
            <div v-if="$root.rebate" class="c-single-car-payments__discount__wrapper">
                <span class="c-single-car-payments__discount">Rabais de {{cash($root.rebate)}}</span>
                <svgIco icon="price-tag-fill" />
            </div>

            <div class="c-single-car-payments__toggle__wrapper">
                <div class="c-single-car-payments__toggle">
                     <button v-if="$root.hasFinance" class="c-single-car-payments__toggle__button" 
                            :class="{'-is-active': $root.type=='finance', '-is-expend': $root.expanded}" 
                            @click="$root.type='finance'; $root.expanded = true">
                        {{cents(finance)}}
                    </button>
                    <button class="c-single-car-payments__toggle__button" 
                            :class="{'-is-active': $root.type=='cash', '-is-expend': $root.expanded}" 
                            @click="$root.type='cash'; $root.expanded = true">
                        {{cash(subtotalCash + tps + tvq)}}
                    </button>
                </div>
                <div class="c-single-car-payments__toggle__label__wrapper">
                    <span v-if="$root.hasFinance" class="c-single-car-payments__toggle__label" data-active="financement" :class="{'-is-active': $root.type=='finance'}">Financement</span>
                    <span class="c-single-car-payments__toggle__label" data-active="comptant" :class="{'-is-active': $root.type=='cash'}">Comptant</span>
                </div>
            </div>
        </div>
        <div class="c-single-car-payments__expend-boxes" v-if="$root.expanded" :class="{'-is-expend': $root.expanded}">
            <div class="c-single-car-payments__expend-boxes__inner">

                <!-- Financement -->
                <div v-if="$root.hasFinance" class="c-single-car-payments__expend__financement" :class="{'-is-active': $root.type=='finance'}">
                    <div class="c-single-car-payments-content__select">
                        <div class="o-select__wrap">
                            <select class="o-select o-select-simple" v-model="$root.select">
                                <option value="weekly">Par semaine</option>
                                <option value="biweekly">Aux 2 semaines</option>
                                <option value="monthly">Mensuel</option>
                            </select>
                        </div>
                        <div class="o-select__wrap">
                            <select class="o-select o-select-simple" v-model="$root.term">
                                <option v-for="(item,key) in $root.percents" :key="key" :value="key">{{key}} mois / {{ pct(item) }}</option>
                                
                            </select>
                        </div>
                    </div>

                    <div class="c-single-car-financement">
                        <div class="c-single-car-payments-content__row">
                            <span class="c-single-car-payments-content__label">Prix du véhicule</span>
                            <span class="c-single-car-payments-content__price">{{cash($root.price+$root.rebate)}}</span>
                        </div>
                        <div v-if="$root.rebate" class="c-single-car-payments-content__row">
                            <span class="c-single-car-payments-content__label">Rabais du concessionnaire</span>
                            <span class="c-single-car-payments-content__discount">-{{cash($root.rebate)}}</span>
                        </div>
                        <div class="c-single-car-payments-content__row">
                            <span class="c-single-car-payments-content__label">Ajoutez une valeur d’échange&nbsp;:</span>
                            <span class="o-input__wrap">
                                <input type="text" class="o-input o-input-smaller" v-model.number="$root.exchange" placeholder="0,00 $">
                            </span>
                        </div>
                        <div class="c-single-car-payments-content__row">
                            <div class="c-single-car-payments-content__taxes">
                                <div class="c-single-car-payments-content__taxes__radio">
                                    <label class="c-single-car-payments-content__taxes__label">
                                        <input type="checkbox" value="1" v-model="$root.includeTaxes">
                                        <span>Inclure les taxes</span>
                                    </label>
                                </div>
                                <div class="c-single-car-payments-content__taxes__row">
                                    <span class="c-single-car-payments-content__label">TPS :</span>
                                    <span class="c-single-car-payments-content__price">{{ cents(tps) }}</span>
                                    <span class="c-single-car-payments-content__label">TVQ :</span>
                                    <span class="c-single-car-payments-content__price">{{ cents(tvq) }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="c-single-car-payments-content__row">
                            <span class="c-single-car-payments-content__label">Ajoutez un versement initial&nbsp;:</span>
                            <span class="o-input__wrap">
                                <input type="text" class="o-input o-input-smaller" v-model.number="$root.initialCash" placeholder="0,00 $">
                            </span>
                        </div>
                        <div class="c-single-car-payments-content__row -total">
                            <span class="c-single-car-payments-content__label">Votre paiement par {{ term }}</span>
                            <span class="c-single-car-payments-content__price">{{cents(finance)}}</span>
                        </div>
                    </div>
                    <Note />
                </div>

                <!-- Comptant -->
                <div class="c-single-car-payments__expend__comptant" :class="{'-is-active': $root.type=='cash'}" >
                    
                    <div class="c-single-car-payments-content__select"></div>
                    <div class="c-single-car-comptant">
                        <div class="c-single-car-payments-content__row">
                            <span class="c-single-car-payments-content__label">Prix du véhicule</span>
                            <span class="c-single-car-payments-content__price">{{cash($root.price+$root.rebate)}}</span>
                        </div>
                        <div v-if="$root.rebate" class="c-single-car-payments-content__row">
                            <span class="c-single-car-payments-content__label">Rabais du concessionnaire</span>
                            <span class="c-single-car-payments-content__discount">-{{cash($root.rebate)}}</span>
                        </div>
                        <div class="c-single-car-payments-content__row">
                            <span class="c-single-car-payments-content__label">Ajoutez une valeur d’échange&nbsp;:</span>
                            <span class="o-input__wrap">
                                <input type="text" class="o-input o-input-smaller" placeholder="0,00 $" v-model="$root.exchange">
                            </span>
                        </div>
                        <div class="c-single-car-payments-content__row">
                            <div class="c-single-car-payments-content__taxes">
                                <div class="c-single-car-payments-content__taxes__radio">
                                    <label class="c-single-car-payments-content__taxes__label">
                                        <input type="checkbox" value="1" v-model="$root.includeTaxes">
                                        <span>Inclure les taxes</span>
                                    </label>
                                </div>
                                <div class="c-single-car-payments-content__taxes__row">
                                    <span class="c-single-car-payments-content__label">TPS :</span>
                                    <span class="c-single-car-payments-content__price">{{ cents(tps) }}</span>
                                    <span class="c-single-car-payments-content__label">TVQ :</span>
                                    <span class="c-single-car-payments-content__price">{{ cents(tvq) }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="c-single-car-payments-content__row -total">
                            <span class="c-single-car-payments-content__label">Votre paiement</span>
                            <span class="c-single-car-payments-content__price">{{cash(subtotalCash + tps + tvq)}}</span>
                        </div>
                    </div>
                    <Note />
                </div>
            </div>
        </div>


        <div class="c-single-car-payments__expend-button__wrapper">
            <button class="c-single-car-payments__expend-button" @click="$root.expanded = !$root.expanded" :class="{'-is-active': $root.expanded}">
                <svgIco icon="arrow-down-slim" />
            </button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'UsedCarPayments',
    
    data() {
        return {
           
        }
    },
    computed: {
        finance() {
            // Calculate loan payment for this.$root.term months for this.$root.price at this.$root.percents[this.$root.term] interest rate
            let price = this.$root.price;
            let term = this.$root.term;
            let rate = this.$root.percents[term];
           
            if (rate == 0) rate = 0.00000001;
            let termreal = term;
            term = termreal / 12;
            let principal = price;
            if (this.$root.exchange) principal -= this.$root.exchange;
            let interest = rate / 100 / 52;
            let payments = term * 52;
            if (this.$root.includeTaxes) principal += this.tps + this.tvq;
            if (this.$root.initialCash) principal -= this.$root.initialCash;
            x = Math.pow(1 + interest, payments);
            weekly = (principal * x * interest) / (x - 1);
            if (this.$root.select == 'biweekly') weekly = weekly * 2;
            if (this.$root.select == 'monthly') weekly = weekly * 52 / 12;
            return weekly;
            
        },
        subtotalCash() {
            return this.$root.price - this.$root.exchange;
        },
        tps() {
            return this.$root.includeTaxes ? this.subtotalCash * 0.05 : 0;
        },
        tvq() {
            return this.$root.includeTaxes ? this.subtotalCash * 0.09975 : 0;
        },
        term() {
            switch(this.$root.select) {
                case 'weekly':
                    return 'semaine';
                    break;
                case 'biweekly':
                    return '2 semaines';
                    break;
                case 'monthly':
                    return 'mois';
                    break;
            }
        }
    },
    methods: {
        
    }
}
</script>